<template>
    <div style="display: flex; height: 100%; width: 100%; justify-content: center; verticial-align: center; align-content: center;">

    <div style="margin: auto; font-size: 190pt; color: var(--primary-color); display: flex; flex-direction: column; text-align: center;">
        <i class="far fa-check-circle"></i>
        <span style="font-size: 14pt; padding-top: 15px;">Export erfolgreich.</span>
    </div>


    <div v-on:click="newTest()" style="margin: auto; font-size: 280pt; cursor: pointer; color: var(--primary-color); display: flex; flex-direction: column; text-align: center;">
        <i class="fas fa-redo"></i>
        <span style="font-size: 14pt; padding-top: 15px;">
            Neuer Test
        </span>
    </div>

    </div>
</template>
<script>
export default ({
    props: [ 'token' ],
    mounted() {
        this.axios.get("/procomcure/?cmd=exportusb")
    },
    methods: {
        newTest() {
            this.$router.push({
                name: 'StartScreen',
            })
        }
    }
})
</script>
